<div class="product-template-container">
  <div class="header">
    <h1 class="title">{{ 'PRODUCT_TEMPLATE' | translate }}</h1>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status"></div>
  </div>

  <div class="product-template-shell" *ngIf="!loading">
    <div class="alert alert-info" *ngIf="infoMessageKey">
      {{ infoMessageKey | translate }}
    </div>
    <div class="alert alert-success" *ngIf="successMessageKey">
      {{ successMessageKey | translate }}
    </div>
    <div class="alert alert-danger" *ngIf="errorMessageKey">
      {{ errorMessageKey | translate }}
    </div>

    <div class="editor-toolbar product-translation-toolbar">
      <div class="language-toggle" role="tablist" [attr.aria-label]="'LANGUAGE_SELECTOR' | translate">
        <button
          type="button"
          class="language-toggle__button"
          [class.is-active]="selectedLanguage === 'es'"
          (click)="selectLanguage('es')">
          {{ 'SPANISH' | translate }}
        </button>
        <button
          type="button"
          class="language-toggle__button"
          [class.is-active]="selectedLanguage === 'en'"
          (click)="selectLanguage('en')">
          {{ 'ENGLISH' | translate }}
        </button>
      </div>
    </div>

    <section class="template-card">
      <div class="card-heading">
        <div>
          <h2>{{ 'PRODUCT_TEMPLATE_GENERAL' | translate }}</h2>
          <p>{{ 'PRODUCT_TEMPLATE_MVP_GENERAL_HELP' | translate }}</p>
        </div>
        <mat-slide-toggle
          class="switch"
          [checked]="templateData.isActive === 1"
          [disabled]="isEnglishMode"
          (change)="templateData.isActive = $event.checked ? 1 : 0">
          {{ templateData.isActive ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}
        </mat-slide-toggle>
      </div>

      <div class="single-grid">
        <div class="field">
          <div class="field-head">
            <label>{{ 'PRODUCT_TEMPLATE_NAME' | translate }}</label>
            <div class="translation-switch-control" *ngIf="isEnglishMode">
              <span class="translation-mode-badge" [class.is-manual]="isEnglishFieldManual('templateName')">
                {{ (isEnglishFieldManual('templateName') ? 'FEATURE_COMPARISON_TRANSLATION_MANUAL' : 'FEATURE_COMPARISON_TRANSLATION_AUTOMATIC') | translate }}
              </span>
              <label class="translation-switch" [title]="'EDIT_MANUALLY' | translate">
                <input
                  type="checkbox"
                  [checked]="isEnglishFieldManual('templateName')"
                  (change)="onManualFieldToggle('templateName', $event)" />
                <span class="translation-switch__slider"></span>
              </label>
            </div>
          </div>
          <input
            type="text"
            [ngModel]="getTemplateNameValue()"
            (ngModelChange)="setTemplateNameValue($event)"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="isEnglishMode && !isEnglishFieldManual('templateName')"
            [ngClass]="{ 'is-invalid': !isEnglishMode && showErrors && !templateData.templateName }" />
          <div class="invalid-feedback" *ngIf="!isEnglishMode && showErrors && !templateData.templateName">
            {{ 'REQUIRED_FIELD' | translate }}
          </div>
        </div>
      </div>
    </section>

    <section class="template-card">
      <div class="card-heading">
        <div>
          <h2>{{ 'PRODUCT_TEMPLATE_PRICE_QUANTITY' | translate }}</h2>
          <p>{{ 'PRODUCT_TEMPLATE_MVP_PRICE_QUANTITY_HELP' | translate }}</p>
        </div>
      </div>

      <div class="settings-grid">
        <div class="setting-row">
          <mat-slide-toggle class="switch" [(ngModel)]="price.visible" [disabled]="isEnglishMode">
            {{ 'PRODUCT_TEMPLATE_SHOW_PRICE' | translate }}
          </mat-slide-toggle>
          <small>{{ 'PRODUCT_TEMPLATE_HIDE_PRICE_RULE' | translate }}</small>
        </div>

        <div class="setting-row setting-row--with-input">
          <mat-slide-toggle class="switch" [(ngModel)]="quantity.visible" [disabled]="isEnglishMode">
            {{ 'PRODUCT_TEMPLATE_SHOW_QUANTITY' | translate }}
          </mat-slide-toggle>

          <div class="field" *ngIf="quantity.visible">
            <div class="field-head">
              <label>{{ 'PRODUCT_TEMPLATE_QUANTITY_LABEL' | translate }}</label>
              <div class="translation-switch-control" *ngIf="isEnglishMode">
                <span class="translation-mode-badge" [class.is-manual]="isEnglishFieldManual('quantity')">
                  {{ (isEnglishFieldManual('quantity') ? 'FEATURE_COMPARISON_TRANSLATION_MANUAL' : 'FEATURE_COMPARISON_TRANSLATION_AUTOMATIC') | translate }}
                </span>
                <label class="translation-switch" [title]="'EDIT_MANUALLY' | translate">
                  <input
                    type="checkbox"
                    [checked]="isEnglishFieldManual('quantity')"
                    (change)="onManualFieldToggle('quantity', $event)" />
                  <span class="translation-switch__slider"></span>
                </label>
              </div>
            </div>
            <input
              type="text"
              [ngModel]="getLabelValue('quantity', quantity.label)"
              (ngModelChange)="setLabelValue('quantity', quantity.label, $event)"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isEnglishMode && !isEnglishFieldManual('quantity')"
              [ngClass]="{ 'is-invalid': !isEnglishMode && isQuantityLabelInvalid() }" />
            <div class="invalid-feedback" *ngIf="!isEnglishMode && isQuantityLabelInvalid()">
              {{ 'REQUIRED_FIELD' | translate }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="template-card">
      <div class="card-heading">
        <div>
          <h2>{{ 'PRODUCT_TEMPLATE_BUTTONS' | translate }}</h2>
          <p>{{ 'PRODUCT_TEMPLATE_MVP_BUTTONS_HELP' | translate }}</p>
        </div>
      </div>

      <div class="settings-grid">
        <div class="setting-row setting-row--with-input">
          <mat-slide-toggle class="switch" [(ngModel)]="buyNow.visible" [disabled]="isEnglishMode">
            {{ 'PRODUCT_TEMPLATE_SHOW_BUY_NOW' | translate }}
          </mat-slide-toggle>

          <div class="field" *ngIf="buyNow.visible">
            <div class="field-head">
              <label>{{ 'PRODUCT_TEMPLATE_BUY_NOW_LABEL' | translate }}</label>
              <div class="translation-switch-control" *ngIf="isEnglishMode">
                <span class="translation-mode-badge" [class.is-manual]="isEnglishFieldManual('buyNow')">
                  {{ (isEnglishFieldManual('buyNow') ? 'FEATURE_COMPARISON_TRANSLATION_MANUAL' : 'FEATURE_COMPARISON_TRANSLATION_AUTOMATIC') | translate }}
                </span>
                <label class="translation-switch" [title]="'EDIT_MANUALLY' | translate">
                  <input
                    type="checkbox"
                    [checked]="isEnglishFieldManual('buyNow')"
                    (change)="onManualFieldToggle('buyNow', $event)" />
                  <span class="translation-switch__slider"></span>
                </label>
              </div>
            </div>
            <input
              type="text"
              [ngModel]="getLabelValue('buyNow', buyNow.label)"
              (ngModelChange)="setLabelValue('buyNow', buyNow.label, $event)"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isEnglishMode && !isEnglishFieldManual('buyNow')"
              [ngClass]="{ 'is-invalid': !isEnglishMode && isBuyNowLabelInvalid() }" />
            <div class="invalid-feedback" *ngIf="!isEnglishMode && isBuyNowLabelInvalid()">
              {{ 'REQUIRED_FIELD' | translate }}
            </div>
          </div>
        </div>

        <div class="setting-row setting-row--with-input">
          <mat-slide-toggle class="switch" [(ngModel)]="addToCart.visible" [disabled]="isEnglishMode">
            {{ 'PRODUCT_TEMPLATE_SHOW_ADD_TO_CART' | translate }}
          </mat-slide-toggle>

          <div class="field" *ngIf="addToCart.visible">
            <div class="field-head">
              <label>{{ 'PRODUCT_TEMPLATE_ADD_TO_CART_LABEL' | translate }}</label>
              <div class="translation-switch-control" *ngIf="isEnglishMode">
                <span class="translation-mode-badge" [class.is-manual]="isEnglishFieldManual('addToCart')">
                  {{ (isEnglishFieldManual('addToCart') ? 'FEATURE_COMPARISON_TRANSLATION_MANUAL' : 'FEATURE_COMPARISON_TRANSLATION_AUTOMATIC') | translate }}
                </span>
                <label class="translation-switch" [title]="'EDIT_MANUALLY' | translate">
                  <input
                    type="checkbox"
                    [checked]="isEnglishFieldManual('addToCart')"
                    (change)="onManualFieldToggle('addToCart', $event)" />
                  <span class="translation-switch__slider"></span>
                </label>
              </div>
            </div>
            <input
              type="text"
              [ngModel]="getLabelValue('addToCart', addToCart.label)"
              (ngModelChange)="setLabelValue('addToCart', addToCart.label, $event)"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isEnglishMode && !isEnglishFieldManual('addToCart')"
              [ngClass]="{ 'is-invalid': !isEnglishMode && isAddToCartLabelInvalid() }" />
            <div class="invalid-feedback" *ngIf="!isEnglishMode && isAddToCartLabelInvalid()">
              {{ 'REQUIRED_FIELD' | translate }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="template-card">
      <div class="card-heading">
        <div>
          <h2>{{ 'PRODUCT_TEMPLATE_TABS' | translate }}</h2>
          <p>{{ 'PRODUCT_TEMPLATE_MVP_TABS_HELP' | translate }}</p>
        </div>
      </div>

      <div class="settings-grid">
        <div class="setting-row setting-row--with-input">
          <mat-slide-toggle class="switch" [(ngModel)]="descriptionTab.visible" [disabled]="isEnglishMode">
            {{ 'PRODUCT_TEMPLATE_SHOW_DETAILS_TAB' | translate }}
          </mat-slide-toggle>

          <div class="field" *ngIf="descriptionTab.visible">
            <div class="field-head">
              <label>{{ 'PRODUCT_TEMPLATE_DETAILS_TAB_LABEL' | translate }}</label>
              <div class="translation-switch-control" *ngIf="isEnglishMode">
                <span class="translation-mode-badge" [class.is-manual]="isEnglishFieldManual('descriptionTab')">
                  {{ (isEnglishFieldManual('descriptionTab') ? 'FEATURE_COMPARISON_TRANSLATION_MANUAL' : 'FEATURE_COMPARISON_TRANSLATION_AUTOMATIC') | translate }}
                </span>
                <label class="translation-switch" [title]="'EDIT_MANUALLY' | translate">
                  <input
                    type="checkbox"
                    [checked]="isEnglishFieldManual('descriptionTab')"
                    (change)="onManualFieldToggle('descriptionTab', $event)" />
                  <span class="translation-switch__slider"></span>
                </label>
              </div>
            </div>
            <input
              type="text"
              [ngModel]="getLabelValue('descriptionTab', descriptionTab.label)"
              (ngModelChange)="setLabelValue('descriptionTab', descriptionTab.label, $event)"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isEnglishMode && !isEnglishFieldManual('descriptionTab')"
              [ngClass]="{ 'is-invalid': !isEnglishMode && isDescriptionLabelInvalid() }" />
            <div class="invalid-feedback" *ngIf="!isEnglishMode && isDescriptionLabelInvalid()">
              {{ 'REQUIRED_FIELD' | translate }}
            </div>
          </div>
        </div>

        <div class="setting-row setting-row--with-input">
          <mat-slide-toggle class="switch" [(ngModel)]="conditionsTab.visible" [disabled]="isEnglishMode">
            {{ 'PRODUCT_TEMPLATE_SHOW_CONDITIONS_TAB' | translate }}
          </mat-slide-toggle>

          <div class="field" *ngIf="conditionsTab.visible">
            <div class="field-head">
              <label>{{ 'PRODUCT_TEMPLATE_CONDITIONS_TAB_LABEL' | translate }}</label>
              <div class="translation-switch-control" *ngIf="isEnglishMode">
                <span class="translation-mode-badge" [class.is-manual]="isEnglishFieldManual('conditionsTab')">
                  {{ (isEnglishFieldManual('conditionsTab') ? 'FEATURE_COMPARISON_TRANSLATION_MANUAL' : 'FEATURE_COMPARISON_TRANSLATION_AUTOMATIC') | translate }}
                </span>
                <label class="translation-switch" [title]="'EDIT_MANUALLY' | translate">
                  <input
                    type="checkbox"
                    [checked]="isEnglishFieldManual('conditionsTab')"
                    (change)="onManualFieldToggle('conditionsTab', $event)" />
                  <span class="translation-switch__slider"></span>
                </label>
              </div>
            </div>
            <input
              type="text"
              [ngModel]="getLabelValue('conditionsTab', conditionsTab.label)"
              (ngModelChange)="setLabelValue('conditionsTab', conditionsTab.label, $event)"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isEnglishMode && !isEnglishFieldManual('conditionsTab')"
              [ngClass]="{ 'is-invalid': !isEnglishMode && isConditionsLabelInvalid() }" />
            <div class="invalid-feedback" *ngIf="!isEnglishMode && isConditionsLabelInvalid()">
              {{ 'REQUIRED_FIELD' | translate }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="actions">
      <button type="button" class="secondary-btn" (click)="cancelChanges()" [disabled]="saving">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="button" class="secondary-btn" (click)="restoreDefaults()" [disabled]="saving">
        {{ 'PRODUCT_TEMPLATE_RESTORE_DEFAULTS' | translate }}
      </button>
      <button type="button" class="primary-btn" (click)="saveTemplate()" [disabled]="saving">
        {{ (saving ? 'SAVING' : 'SAVE') | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal product-template-confirm-modal" id="productTemplateSuccessModal" tabindex="-1">
  <div class="modal-dialog product-template-modal-dialog" role="document">
    <div class="modal-content product-template-modal-content">
      <div class="modal-body product-template-modal-body">
        <div class="success-check-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none"
               stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="14 26 22 34 38 18" />
          </svg>
        </div>
        <h3 class="text-center">{{ 'SUCCESS' | translate }}</h3>
        <p class="text-center">{{ 'PRODUCT_TEMPLATE_SAVED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">
          {{ 'CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
